<template>
  <div class="add-user" ref="userForm" :class="valid">
    <v-card>
      <v-card-title class="">
        <h3>Approve / Reject User requests</h3>
      </v-card-title>

      <v-card-text>
        <v-form>
            <v-layout column>
                <label>Full Name</label>
                <h3 class="mb-3">{{ user.first_name }} {{ user.last_name }}</h3>

                <label>Email</label>
                <p>{{ user.email }}</p>

                <label>Created By</label>
                <p>{{ user.created_by }}</p>

                <label>Role</label>
                <v-select
                    v-model="user.role_id"
                    outline
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || 'Role is required']"
                ></v-select>
            </v-layout>
  

          <label>Status</label>
          <v-select
            v-model="user.status"
            outline
            :items="statuses"
            item-text="text"
            item-value="value"
            :rules="[(v) => !!v || 'Status is required']"
          ></v-select>
          <label>Comment</label>
          <v-textarea outline v-model="user.comment"> </v-textarea>
          
          <v-alert :value="error" color="error" icon="warning" outline>
            {{ error }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="primary" arge round @click="editUser" block> Update </v-btn>
        <v-btn color="primary" arge round flat @click="$emit('closeDialog')" block>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "updateUserStatus",
  props: {
    userData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    roles: {
        type: Array
    }
  },
  data() {
    return {
      valid: false,
      confirmPassword: "",
      user: {
        status: "",
        comment: "",
      },
      statuses: [
        { text: "Pending", value: "pending" },
        { text: "Approved", value: "approved" },
        { text: "Rejected", value: "rejected" },
        { text: "Blocked", value: "blocked" },
        { text: "Locked", value: "locked" },
        { text: "Unlocked", value: "unlocked" },
      ],
      error: "",
    };
  },
  methods: {
    editUser() {
      this.error = "";
      this.$http
        .put(`/users/${this.user.id}/status`, this.user)
        .then((response) => {
          this.$emit("updated", response.data);
          this.$emit("closeDialog");
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
  watch: {
    userData() {
      this.user = {};
      this.error = "";
      this.user = _.cloneDeep(this.userData);
      // console.log('user', this.user)
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__title {
  justify-content: center;
  text-transform: capitalize;
}

.v-card__text {
  width: 80%;
  margin: auto;
}
.v-card__actions {
  flex-direction: column;
  .v-btn {
    max-width: 80%;
  }
}
</style>
